import React, { useState } from "react";

// import JS files
import MuiModal from "../shares/MuiModal";
import MuiButton from "../shares/MuiButton";

// import Others files
import removeIcon from "../../imgs/remove.svg";

const RemoveFileModal = (props) => {
  return (
    <>
      <MuiModal
        openModal={props.openModal}
        setOpenModal={props.setOpenModal}
        width="w-2/5"
      >
        <div className="flex flex-col items-center justify-center p-4">
          <img src={removeIcon} />
          <p className="font-bold text-mygray-700 mt-8">
            آیا از حذف مدرک موردنظر اطمینان دارید؟
          </p>
          <div className="mt-8 flex justify-between w-1/2">
            <MuiButton
              onClick={() => props.setOpenModal(false)}
              type="submit"
              variant="outlined"
              color="error"
              text="انصراف"
            />
            <MuiButton
              onClick={() => props.removeFile()}
              type="submit"
              variant="contained"
              color="error"
              text="حذف"
            />
          </div>
        </div>
      </MuiModal>
    </>
  );
};

export default RemoveFileModal;
